const SUPPORTED_BROWSER_LANGUAGES = {
  af: 'af',
  en: 'en',
  da: 'da',
  'zh-CN': 'zh-Hans',
  'zh-TW': 'zh-Hant',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  hr: 'hr',
  nl: 'nl',
  no: 'no',
  fi: 'fi',
  fil: 'fil',
  fr: 'fr',
  de: 'de',
  gu: 'gu',
  hi: 'hi',
  hu: 'hu',
  id: 'id',
  ja: 'ja',
  jv: 'jv',
  it: 'it',
  ms: 'ms',
  ml: 'ml',
  mr: 'mr',
  pa: 'pa',
  pl: 'pl',
  pt: 'pt',
  'pt-BR': 'pt-BR',
  ro: 'ro',
  ru: 'ru',
  sr: 'sr',
  sk: 'sk',
  th: 'th',
  ur: 'ur',
  ca: 'ca',
  es: 'es',
  sv: 'sv',
  tr: 'tr',
  cs: 'cs',
  kn: 'kn',
  uk: 'uk',
  vi: 'vi',
};
export default SUPPORTED_BROWSER_LANGUAGES;
